import { useQuery } from '@tanstack/react-query';

import { fetchOCClaimEmailNotifications } from '../../data-provider/over-charge-claim-emails';

export const useOCClaimEmailNotifications = ({ fbocKey, open }: { fbocKey: number | undefined; open: boolean }) => {
  return useQuery({
    enabled: open && Boolean(fbocKey),
    queryFn: () => fetchOCClaimEmailNotifications(fbocKey as number),
    queryKey: ['claims-over-charge-email-notifications', fbocKey],
    staleTime: 1000 * 5,
  });
};
